// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_CATEGORY_FINANCE = "GET_CATEGORY_FINANCE";
export const GET_CATEGORY_FINANCE_ORGANIZED = "GET_CATEGORY_FINANCE_ORGANIZED";
export const CREATE_CATEGORY_FINANCE = "CREATE_CATEGORY_FINANCE";
export const UPDATE_CATEGORY_FINANCE = "UPDATE_CATEGORY_FINANCE";
export const DELETE_CATEGORY_FINANCE = "DELETE_CATEGORY_FINANCE";
export const GET_CATEGORIES_FINANCE_SELECT = "GET_CATEGORIES_FINANCE_SELECT";
